// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../contexts/AuthContext";
// import { db } from "../firebase/config";
// import { collection, query, where, onSnapshot, limit, getDocs, orderBy } from "firebase/firestore";
// import { createTrackingLink, deleteTrackingLink } from "../utils/linkService";
// import {
//   Link2, Zap, Activity,
//   ChevronRight, Clock, Smartphone,
//   Globe, Eye, CreditCard, X, MapPin,
//   List, BarChart2, Trash2, AlertCircle
//   List, BarChart2, Trash2, AlertCircle, Ticket
// } from "lucide-react";

// function toIST(dateInput) {
//   if (!dateInput) return "-";
//   const date = dateInput?.toMillis ? new Date(dateInput.toMillis()) : new Date(dateInput);
//   return date.toLocaleString("en-IN", {
//     timeZone: "Asia/Kolkata",
//     day: "2-digit", month: "2-digit", year: "numeric",
//     hour: "2-digit", minute: "2-digit", second: "2-digit",
//   });
// }

// function toISTShort(dateInput) {
//   if (!dateInput) return "-";
//   const date = dateInput?.toMillis ? new Date(dateInput.toMillis()) : new Date(dateInput);
//   return date.toLocaleString("en-IN", {
//     timeZone: "Asia/Kolkata",
//     day: "2-digit", month: "short",
//     hour: "2-digit", minute: "2-digit",
//   });
// }

// function detectInputType(value) {
//   if (!value) return null;
//   const trimmed = value.trim();
//   if (trimmed.includes(".") || trimmed.startsWith("http")) return "url";
//   if (/^[a-zA-Z0-9]+$/.test(trimmed)) return "code";
//   return null;
// }

// export default function Dashboard() {
//   const { currentUser, userProfile, fetchUserProfile } = useAuth();
//   const [links, setLinks] = useState([]);
//   const [label, setLabel] = useState("");
//   const [inputValue, setInputValue] = useState("");
//   const [generating, setGenerating] = useState(false);
//   const [error, setError] = useState("");
//   const [showPayment, setShowPayment] = useState(false);
//   const navigate = useNavigate();
//   const detectedType = detectInputType(inputValue);
//   const credits = userProfile?.credits ?? 0;
//   const [deletingToken, setDeletingToken] = useState(null);
//   const [deleteModal, setDeleteModal] = useState({ isOpen: false, link: null });

//   useEffect(() => {
//     if (!currentUser) return;
//     const q = query(collection(db, "trackingLinks"), where("uid", "==", currentUser.uid), orderBy("createdAt", "desc"), limit(20));
//     const unsub = onSnapshot(q, (snap) => {
//       const data = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
//       data.sort((a, b) => (b.createdAt?.toMillis?.() ?? 0) - (a.createdAt?.toMillis?.() ?? 0));
//       setLinks(data);
//     });
//     return unsub;
//   }, [currentUser]);

//   async function handleGenerate() {
//     const type = detectInputType(inputValue);
//     if (type !== "url") { setError("Please enter a valid URL"); return; }
//     if (credits < 1) { setShowPayment(true); return; }

//     const finalUrl = inputValue.startsWith("http") ? inputValue : "https://" + inputValue;
//     setGenerating(true);
//     setError("");

//     try {
//       const result = await createTrackingLink(currentUser.uid, label || "Tracking Link", finalUrl);
//       const linkData = {
//         originalUrl: finalUrl,
//         trackingUrl: result.trackingUrl,
//         shortUrl: result.shortUrl || result.trackingUrl,
//         token: result.token,
//         tinyUrl: result.tinyUrl || null,
//         isGdUrl: result.isGdUrl || null,
//         createdAt: new Date().toISOString(),
//       };
//       sessionStorage.setItem("traxelon_last_link", JSON.stringify(linkData));
//       navigate("/generate", { state: linkData });
//     } catch (err) {
//       setError(err.message);
//     }
//     setGenerating(false);
//   }

//   function handleSelectLink(link) {
//     const linkData = {
//       originalUrl: link.destinationUrl || link.originalUrl || "",
//       trackingUrl: link.trackingUrl,
//       shortUrl: link.shortUrl || link.trackingUrl,
//       token: link.token,
//       tinyUrl: link.tinyUrl || null,
//       isGdUrl: link.isGdUrl || null,
//       createdAt: link.createdAt,
//     };
//     sessionStorage.setItem("traxelon_last_link", JSON.stringify(linkData));
//     navigate("/generate", { state: linkData });
//   }

//   return (
//     <div className="min-h-screen bg-surface pt-16 text-text-primary">
//       <div className="max-w-7xl mx-auto px-4 py-8">

//         {/* ── Top header ── */}
//         <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
//           <div>
//             <h1 className="font-display text-4xl tracking-wider">COMMAND <span className="text-primary">CENTER</span></h1>
//             <p className="font-body text-sm text-text-secondary mt-1">
//               Welcome back, <span className="text-primary">{userProfile?.displayName || "Officer"}</span>
//               {userProfile?.badgeId && <span className="text-text-muted"> · Badge #{userProfile.badgeId}</span>}
//             </p>
//           </div>
//           <div className="flex items-center gap-3">
//             <div className="bg-surface-card border border-surface-border rounded-xl px-5 py-3 flex items-center gap-3">
//               <Zap className="w-5 h-5 text-primary" />
//               <div>
//                 <div className="font-mono text-2xl text-primary leading-none">{credits}</div>
//                 <div className="font-body text-xs text-text-muted">Credits</div>
//               </div>
//             </div>
//             <button onClick={() => setShowPayment(true)} className="px-4 py-3 bg-primary/10 border border-primary/30 text-primary rounded-xl font-body text-sm hover:bg-primary/20 transition-colors flex items-center gap-2">
//             <button
//               onClick={() => setShowPayment(true)}
//               className="px-4 py-3 bg-primary/10 border border-primary/30 text-primary rounded-xl font-body text-sm hover:bg-primary/20 transition-colors flex items-center gap-2"
//             >
//               <CreditCard className="w-4 h-4" /> Buy Credits
//             </button>
//           </div>
//         </div>

//         {/* ── Stats ── */}
//         <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
//           {[
//             { label: "Total Links", value: links.length, icon: <Link2 className="w-4 h-4" /> },
//             { label: "Total Captures", value: links.reduce((a, l) => a + (l.captureCount || 0), 0), icon: <Eye className="w-4 h-4" /> },
//             { label: "Active Links", value: links.filter((l) => l.active).length, icon: <Activity className="w-4 h-4" /> },
//             { label: "Total Clicks", value: links.reduce((a, l) => a + (l.clicks || 0), 0), icon: <Globe className="w-4 h-4" /> },
//           ].map((stat) => (
//             <div key={stat.label} className="bg-surface-card border border-surface-border rounded-xl p-4 hover:border-primary/30 transition-colors">
//               <div className="flex items-center gap-2 text-text-muted mb-2">
//                 {stat.icon}
//                 <span className="font-body text-xs uppercase tracking-wider">{stat.label}</span>
//               </div>
//               <div className="font-display text-3xl text-text-primary">{stat.value}</div>
//             </div>
//           ))}
//         </div>

//         {/* ── URL Generator ── */}
//         <div className="bg-surface-elevated border border-surface-border rounded-2xl p-6 mb-8">
//           <div className="text-center mb-6">
//             <h2 className="font-display text-3xl tracking-wider mb-2">
//               CREATE <span className="text-primary">TRACKING URL</span>
//             </h2>
//             <p className="font-body text-sm text-text-muted">Enter any URL to generate a covert tracking link</p>
//           </div>

//           <input
//             type="text"
//             value={inputValue}
//             onChange={(e) => { setInputValue(e.target.value); setError(""); }}
//             placeholder="Enter URL or Tracking Code..."
//             className="w-full bg-surface border border-surface-border rounded-xl px-5 py-4 font-body text-base text-text-primary placeholder:text-text-muted focus:outline-none focus:border-primary transition-colors text-center"
//           />

//           {inputValue && (
//             <p className="text-xs text-text-muted text-center mt-2">
//               Detected: <span className="text-primary">
//                 {detectedType === "url" ? "URL" : detectedType === "code" ? "Tracking Code" : "Unknown"}
//               </span>
//             </p>
//           )}

//           {error && <p className="font-body text-sm text-accent text-center mt-2">{error}</p>}

//           <div className="flex gap-3 justify-center mt-6">
//             <button
//               type="button"
//               onClick={handleGenerate}
//               className="flex items-center gap-2 px-8 py-3 bg-primary text-surface font-body font-bold rounded-xl hover:bg-primary-dark transition-all shadow-glow"
//             >
//               <Link2 className="w-4 h-4" />
//               {generating ? "Creating..." : "Create URL"}
//             </button>

//             <button
//               type="button"
//               onClick={async () => {
//                 setError("");
//                 const type = detectInputType(inputValue);
//                 if (type !== "code") { setError("Please enter a valid tracking code"); return; }
//                 try {
//                   const q = query(collection(db, "trackingLinks"), where("token", "==", inputValue.trim()), limit(1));
//                   const snap = await getDocs(q);
//                   if (snap.empty) { setError("Invalid tracking code"); return; }
//                   const data = snap.docs[0].data();
//                   const linkData = {
//                     originalUrl: data.destinationUrl || data.originalUrl || null,
//                     trackingUrl: data.trackingUrl || null,
//                     shortUrl: data.shortUrl || data.trackingUrl || null,
//                     token: data.token || null,
//                     tinyUrl: data.tinyUrl || null,
//                     isGdUrl: data.isGdUrl || null,
//                     createdAt: data.createdAt || null,
//                   };
//                   sessionStorage.setItem("traxelon_last_link", JSON.stringify(linkData));
//                   navigate("/generate", { state: linkData });
//                 } catch (err) {
//                   setError("Something went wrong");
//                 }
//               }}
//               className="flex items-center gap-2 px-8 py-3 border border-surface-border text-text-secondary rounded-xl hover:border-primary hover:text-primary transition-all"
//             >
//               <Eye className="w-4 h-4" /> Tracking Code
//             </button>
//           </div>
//         </div>

//         <div className="flex gap-6 pb-20">
//           {/* ── LEFT: All Previous Links ── */}
//           <div className="w-full flex flex-col">
//           <div className="w-1/2 flex flex-col">
//             <div className="bg-surface-elevated border border-surface-border rounded-2xl overflow-hidden">
//               <div className="border-b border-surface-border px-6 py-4 flex items-center justify-between flex-shrink-0">
//                 <div className="flex items-center gap-2">
//                   <List className="w-4 h-4 text-primary" />
//                   <h3 className="font-display text-xl tracking-wider">
//                     MY <span className="text-primary">LINKS</span>
//                   </h3>
//                   {links.length > 0 && (
//                     <span className="font-mono text-xs text-text-muted bg-surface border border-surface-border px-2 py-0.5 rounded-full">
//                       {links.length}
//                     </span>
//                   )}
//                 </div>
//                 <span className="font-body text-xs text-text-muted italic">Click to inspect</span>
//               </div>

//               <div className="overflow-y-auto p-4 space-y-2" style={{ maxHeight: 462 }}>
//                 {links.length === 0 ? (
//                   <div className="flex flex-col items-center justify-center py-20 text-center">
//                     <BarChart2 className="w-10 h-10 text-text-muted mb-3 opacity-40" />
//                     <p className="font-body text-sm text-text-muted">No links yet.</p>
//                     <p className="font-body text-xs text-text-muted mt-1">Generate your first tracking link above.</p>
//                   </div>
//                 ) : (
//                   links.map((link) => {
//                     const captureCount = link.captureCount || 0;
//                     const hasGPS = link.hasGPS || false;

//                     return (
//                       <div
//                         key={link.id}
//                         onClick={() => handleSelectLink(link)}
//                         className="w-full text-left rounded-xl border border-surface-border bg-surface hover:border-primary/30 hover:bg-surface-elevated transition-all duration-200 group"
//                       >
//                         <div className="px-4 py-3.5">
//                           <div className="flex items-start justify-between gap-2 mb-2">
//                             <div className="flex-1 min-w-0">
//                               <div className="font-mono text-xs text-text-muted truncate mb-0.5">
//                                 {link.destinationUrl || link.originalUrl || link.label || "-"}
//                               </div>
//                               <div className="font-mono text-xs text-primary truncate">
//                                 {link.shortUrl || link.trackingUrl}
//                               </div>
//                             </div>
//                             <div className="flex items-center gap-2 flex-shrink-0 mt-0.5">
//                               <button
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   setDeleteModal({ isOpen: true, link });
//                                 }}
//                                 className="p-1 rounded-lg text-text-muted hover:text-red-400 hover:bg-red-500/10 transition-colors"
//                               >
//                                 {deletingToken === link.token
//                                   ? <span className="font-mono text-xs text-red-400">...</span>
//                                   : <Trash2 className="w-3.5 h-3.5" />}
//                               </button>
//                               <ChevronRight className="w-4 h-4 text-text-muted group-hover:translate-x-0.5 transition-transform" />
//                             </div>
//                           </div>

//                           <div className="flex items-center gap-2 flex-wrap">
//                             <div className="flex items-center gap-1 text-text-muted">
//                               <Clock className="w-3 h-3" />
//                               <span className="font-body text-xs">{toISTShort(link.createdAt)}</span>
//                             </div>

//                             <div className={`flex items-center gap-1 font-mono text-xs px-1.5 py-0.5 rounded-full border ${captureCount > 0
//                               ? "text-green-400 border-green-500/20 bg-green-500/10"
//                               : "text-text-muted border-surface-border"
//                               }`}>
//                               <Eye className="w-3 h-3" />
//                               {captureCount} capture{captureCount !== 1 ? "s" : ""}
//                             </div>

//                             {hasGPS && (
//                               <span className="flex items-center gap-1 font-mono text-xs text-yellow-400 border border-yellow-500/20 bg-yellow-500/10 px-1.5 py-0.5 rounded-full">
//                                 <MapPin className="w-3 h-3" /> GPS
//                               </span>
//                             )}
//                           </div>
//                         </div>
//                       </div>
//                     );
//                   })
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* ── RIGHT: How It Works ── */}
//           {/* <div className="w-1/2 flex flex-col">
//           <div className="w-1/2 flex flex-col">
//             <div className="bg-surface-elevated border border-surface-border rounded-2xl overflow-hidden">
//               <div className="border-b border-surface-border px-8 py-5">
//                 <h3 className="font-display text-2xl tracking-wider">
//                   HOW IT <span className="text-primary">WORKS</span>
//                 </h3>
//               </div>
//               <div className="divide-y divide-surface-border">
//                 {[
//                   { icon: <Link2 className="w-5 h-5 text-primary" />, title: "Paste any URL", desc: "Enter any website link — our system wraps it in a tracking link." },
//                   { icon: <Globe className="w-5 h-5 text-primary" />, title: "Share the link", desc: "Send the generated URL to your target via WhatsApp, SMS, or email." },
//                   { icon: <Smartphone className="w-5 h-5 text-primary" />, title: "They click it", desc: "The moment they open it, 150+ data points are captured silently." },
//                   { icon: <Eye className="w-5 h-5 text-primary" />, title: "View captures", desc: "Results appear instantly in real time — no refresh needed." },
//                 ].map((step, i) => (
//                   <div key={i} className="flex items-center gap-6 px-8 py-6 hover:bg-surface transition-colors">
//                     <div className="w-12 h-12 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center flex-shrink-0">
//                       {step.icon}
//                     </div>
//                     <div>
//                       <div className="font-body text-base font-semibold text-text-primary mb-1">{step.title}</div>
//                       <div className="font-body text-sm text-text-muted">{step.desc}</div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//               <div className="px-8 py-5 border-t border-surface-border">
//                 <p className="font-body text-xs text-text-muted text-center">
//                   ← Click any link to view its full details and captures
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Delete Confirmation Modal */}
//       {deleteModal.isOpen && (
//         <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center px-4">
//           <div className="bg-surface-elevated border border-surface-border rounded-2xl w-full max-w-md shadow-card overflow-hidden">
//             <div className="border-b border-surface-border px-6 py-4 flex items-center justify-between">
//               <div className="flex items-center gap-3">
//                 <div className="w-10 h-10 rounded-xl bg-red-500/10 border border-red-500/30 flex items-center justify-center">
//                   <AlertCircle className="w-5 h-5 text-red-400" />
//                 </div>
//                 <h2 className="font-display text-xl tracking-wider text-text-primary">Confirm Delete</h2>
//               </div>
//               <button onClick={() => setDeleteModal({ isOpen: false, link: null })} disabled={deletingToken} className="text-text-muted hover:text-text-primary disabled:opacity-50">
//                 <X className="w-5 h-5" />
//               </button>
//             </div>

//             <div className="px-6 py-6">
//               <p className="font-body text-text-secondary mb-4">
//                 Are you sure you want to delete this link and all its captures?
//               </p>
//               <div className="bg-surface border border-surface-border rounded-xl p-3 mb-6">
//                 <p className="font-mono text-xs text-text-muted break-all">{deleteModal.link?.shortUrl || deleteModal.link?.trackingUrl || ""}</p>
//               </div>
//               <p className="font-body text-xs text-red-400/80">
//                 ⚠️ This action cannot be undone.
//               </p>
//             </div>

//             <div className="border-t border-surface-border px-6 py-4 flex items-center gap-3">
//               <button
//                 onClick={() => setDeleteModal({ isOpen: false, link: null })}
//                 disabled={deletingToken}
//                 className="flex-1 px-4 py-2.5 bg-surface border border-surface-border text-text-primary font-body font-semibold rounded-lg hover:bg-surface-card disabled:opacity-50 transition-colors"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={async () => {
//                   setDeletingToken(deleteModal.link.token);
//                   try {
//                     await deleteTrackingLink(deleteModal.link.token, currentUser.uid);
//                   } catch (err) {
//                     alert("Failed to delete: " + err.message);
//                   }
//                   setDeletingToken(null);
//                   setDeleteModal({ isOpen: false, link: null });
//                 }}
//                 disabled={deletingToken}
//                 className="flex-1 px-4 py-2.5 bg-red-600 hover:bg-red-700 text-white font-body font-semibold rounded-lg disabled:opacity-60 transition-colors flex items-center justify-center gap-2"
//               >
//                 <Trash2 className="w-4 h-4" />
//                 {deletingToken ? "Deleting..." : "Delete"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {showPayment && (
//         <PaymentModal
//           onClose={() => setShowPayment(false)}
//           uid={currentUser?.uid}
//           fetchUserProfile={fetchUserProfile}
//         />
//       )}
//     </div>
//   );
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // PaymentModal — handles both credit purchases (Razorpay) and voucher redemption
// // ─────────────────────────────────────────────────────────────────────────────

// function PaymentModal({ onClose, uid, fetchUserProfile }) {
//   const plans = [
//   { credits: 1,   price: 0,    label: "Free Trial",        free: true },
//   { credits: 5,   price: 250,  label: "Starter Pack" },
//   { credits: 10,  price: 400,  label: "Basic Pack" },
//   { credits: 50,  price: 1500, label: "Investigation Pack", popular: true },
//   { credits: 100, price: 2000, label: "Department Pack" },
//   { credits: 500, price: 5000, label: "Enterprise Pack" },
// ];

//   const [selected, setSelected] = useState(1);
//   const [processing, setProcessing] = useState(false);
//   const [done, setDone] = useState(false);
//   const [doneMessage, setDoneMessage] = useState({ credits: 0, label: "" });

//   // Coupon / voucher shared input
//   const [codeInput, setCodeInput] = useState("");
//   const [codeError, setCodeError] = useState("");
//   const [codeApplied, setCodeApplied] = useState(false);
//   const [isVoucher, setIsVoucher] = useState(false);
//   const [discount, setDiscount] = useState(0);

//   // Active tab: "buy" | "voucher"
//   const [tab, setTab] = useState("buy");

//   const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5001";
//   const RAZORPAY_KEY = process.env.REACT_APP_RAZORPAY_KEY_ID;

//   const originalPrice = plans[selected].price;
//   const finalPrice = Math.max(0, originalPrice - discount);

//   // ── Reset coupon/voucher state when switching plan ──────────────────────────
//   function resetCode() {
//     setCodeInput("");
//     setCodeError("");
//     setCodeApplied(false);
//     setIsVoucher(false);
//     setDiscount(0);
//   }

//   // ── Apply button handler — tries voucher first, falls back to coupon ────────
//   async function handleApplyCode() {
//     if (!codeInput.trim()) return;
//     setProcessing(true);
//     setCodeError("");
//     setIsVoucher(false);

//     const code = codeInput.trim().toUpperCase();

//     try {
//       // 1. Try voucher redemption first
//       const voucherRes = await fetch(`${BACKEND_URL}/api/vouchers/redeem`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ code, uid }),
//       });
//       const voucherData = await voucherRes.json();

//       if (voucherData.success) {
//         // Voucher redeemed — credits added immediately
//         await fetchUserProfile(uid);
//         setIsVoucher(true);
//         setCodeApplied(true);
//         setDoneMessage({ credits: voucherData.credits, label: "Voucher" });
//         setDone(true);
//         setProcessing(false);
//         return;
//       }

//       // If it looked like a voucher but failed for a real reason (expired, redeemed)
//       // don't fall through to coupon check
//       if (voucherData.error && voucherData.error !== "Invalid voucher code.") {
//         setCodeError(voucherData.error);
//         setProcessing(false);
//         return;
//       }

//       // 2. Fall back to coupon
//       const couponRes = await fetch(`${BACKEND_URL}/api/payment/validate-coupon`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ code }),
//       });
//       const couponData = await couponRes.json();

//       if (couponData.success) {
//         let disc = 0;
//         if (couponData.discountPercent) {
//           disc = Math.round((originalPrice * couponData.discountPercent) / 100);
//         } else if (couponData.discountAmount) {
//           disc = couponData.discountAmount;
//         }
//         setDiscount(disc);
//         setCodeApplied(true);
//       } else {
//         setCodeError(couponData.error || "Invalid code.");
//       }
//     } catch {
//       setCodeError("Failed to validate code. Please try again.");
//     }

//     setProcessing(false);
//   }

//   // ── Razorpay purchase ───────────────────────────────────────────────────────
//   async function handlePurchase() {
//     if (!uid) return;
//     if (!window.Razorpay) {
//       alert("Razorpay SDK not loaded. Please check your internet connection.");
//       return;
//     }
//     setProcessing(true);

//     try {
//       const orderRes = await fetch(`${BACKEND_URL}/api/payment/create-order`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           amount: finalPrice,
//           currency: "INR",
//           notes: { uid, plan: plans[selected].label, credits: plans[selected].credits },
//         }),
//       });
//       const orderData = await orderRes.json();
//       if (orderData.error) throw new Error(orderData.error);

//       const options = {
//         key: RAZORPAY_KEY,
//         amount: orderData.amount,
//         currency: orderData.currency,
//         name: "Traxelon",
//         description: `Purchase ${plans[selected].credits} Credits`,
//         order_id: orderData.id,
//         handler: async function (response) {
//           try {
//             const verifyRes = await fetch(`${BACKEND_URL}/api/payment/verify-payment`, {
//               method: "POST",
//               headers: { "Content-Type": "application/json" },
//               body: JSON.stringify({
//                 razorpay_order_id: response.razorpay_order_id,
//                 razorpay_payment_id: response.razorpay_payment_id,
//                 razorpay_signature: response.razorpay_signature,
//                 uid,
//                 credits: plans[selected].credits,
//                 planLabel: plans[selected].label,
//                 amount: finalPrice,
//               }),
//             });
//             const verifyData = await verifyRes.json();
//             if (verifyData.success) {
//               await fetchUserProfile(uid);
//               setDoneMessage({ credits: plans[selected].credits, label: plans[selected].label });
//               setDone(true);
//             } else {
//               alert("Payment verification failed: " + verifyData.error);
//             }
//           } catch (err) {
//             alert("Verification Error: " + err.message);
//           }
//           setProcessing(false);
//         },
//         prefill: { name: "", email: "", contact: "" },
//         theme: { color: "#00D4FF" },
//         modal: { ondismiss: () => setProcessing(false) },
//       };

//       const rzp = new window.Razorpay(options);
//       rzp.open();
//     } catch (err) {
//       alert("Error: " + err.message);
//       setProcessing(false);
//     }
//   }

//   // ── Standalone voucher-only redeem (Redeem tab) ─────────────────────────────
//   const [voucherInput, setVoucherInput] = useState("");
//   const [voucherError, setVoucherError] = useState("");
//   const [voucherProcessing, setVoucherProcessing] = useState(false);

//   async function handleRedeemVoucher() {
//     if (!voucherInput.trim()) return;
//     setVoucherProcessing(true);
//     setVoucherError("");

//     try {
//       const res = await fetch(`${BACKEND_URL}/api/vouchers/redeem`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ code: voucherInput.trim().toUpperCase(), uid }),
//       });
//       const data = await res.json();
//       if (data.success) {
//         await fetchUserProfile(uid);
//         setDoneMessage({ credits: data.credits, label: "Voucher" });
//         setDone(true);
//       } else {
//         setVoucherError(data.error || "Invalid voucher.");
//       }
//     } catch {
//       setVoucherError("Failed to redeem voucher. Please try again.");
//     }
//     setVoucherProcessing(false);
//   }

//   // ─── Render ─────────────────────────────────────────────────────────────────
//   return (
//     <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center px-4">
//       <div className="bg-surface-elevated border border-surface-border rounded-2xl p-6 w-full max-w-md shadow-card">

//         {/* Header */}
//         <div className="flex items-center justify-between mb-5">
//           <h2 className="font-display text-2xl tracking-wider text-text-primary">
//             {tab === "buy" ? <>BUY <span className="text-primary">CREDITS</span></> : <>REDEEM <span className="text-primary">VOUCHER</span></>}
//           </h2>
//           <button onClick={onClose} className="text-text-muted hover:text-text-primary">
//             <X className="w-5 h-5" />
//           </button>
//         </div>

//         {/* Done state */}
//         {done ? (
//           <div className="text-center py-8">
//             <div className="text-5xl mb-4">✅</div>
//             <h3 className="font-display text-2xl text-primary mb-2">Credits Added!</h3>
//             <p className="font-body text-text-secondary text-sm">
//               <span className="text-primary font-semibold">+{doneMessage.credits} credits</span> added to your account.
//             </p>
//             <button onClick={onClose} className="mt-6 px-6 py-3 bg-primary text-surface font-body font-bold rounded-lg">
//               Back to Dashboard
//             </button>
//           </div>
//         ) : (
//           <>
//             {/* Tab switcher */}
//             <div className="flex gap-2 mb-5 bg-surface rounded-xl p-1 border border-surface-border">
//               <button
//                 onClick={() => setTab("buy")}
//                 className={`flex-1 flex items-center justify-center gap-2 py-2 rounded-lg font-body text-sm font-semibold transition-all ${tab === "buy" ? "bg-primary text-surface shadow-glow" : "text-text-muted hover:text-text-primary"}`}
//               >
//                 <CreditCard className="w-4 h-4" /> Buy Credits
//               </button>
//               <button
//                 onClick={() => setTab("voucher")}
//                 className={`flex-1 flex items-center justify-center gap-2 py-2 rounded-lg font-body text-sm font-semibold transition-all ${tab === "voucher" ? "bg-primary text-surface shadow-glow" : "text-text-muted hover:text-text-primary"}`}
//               >
//                 <Ticket className="w-4 h-4" /> Redeem Voucher
//               </button>
//             </div>

//             {/* ── BUY TAB ── */}
//             {tab === "buy" && (
//               <>
//                 <div className="space-y-3 mb-5">
//                   {plans.map((plan, i) => (
//                     <button
//                       key={i}
//                       onClick={() => { setSelected(i); resetCode(); }}
//                       className={`w-full text-left p-4 rounded-xl border transition-all ${selected === i ? "border-primary bg-primary/10 shadow-glow" : "border-surface-border bg-surface hover:border-primary/40"}`}
//                     >
//                       <div className="flex items-center justify-between">
//                         <div>
//                           <div className="flex items-center gap-2">
//                             <span className="font-display text-lg text-text-primary">{plan.label}</span>
//                             {plan.popular && <span className="bg-primary text-surface text-xs px-2 py-0.5 rounded-full font-body font-bold">POPULAR</span>}
//                           </div>
//                           <div className="font-body text-sm text-text-secondary mt-0.5">{plan.credits} tracking links</div>
//                         </div>
//                         <div className="text-right">
//                           <div className="font-display text-2xl text-primary">Rs.{plan.price}</div>
//                           <div className="font-body text-xs text-text-muted">Rs.{(plan.price / plan.credits).toFixed(0)}/link</div>
//                         </div>
//                       </div>
//                     </button>
//                   ))}
//                 </div>

//                 {/* Coupon code input (also accepts vouchers) */}
//                 <div className="mb-5">
//                   <div className="flex gap-2">
//                     <input
//                       type="text"
//                       placeholder="Coupon or Voucher Code"
//                       value={codeInput}
//                       onChange={(e) => setCodeInput(e.target.value.toUpperCase())}
//                       disabled={codeApplied || processing}
//                       className="flex-1 bg-surface border border-surface-border rounded-lg px-4 py-2 font-mono text-sm text-text-primary focus:outline-none focus:border-primary uppercase placeholder:normal-case"
//                     />
//                     <button
//                       onClick={handleApplyCode}
//                       disabled={!codeInput || codeApplied || processing}
//                       className="px-4 py-2 bg-surface-card border border-surface-border text-text-primary rounded-lg font-body text-sm hover:border-primary transition-colors disabled:opacity-50"
//                     >
//                       {processing ? "..." : "Apply"}
//                     </button>
//                   </div>
//                   {codeError && <p className="text-accent text-xs mt-1 ml-1">{codeError}</p>}
//                   {codeApplied && !isVoucher && (
//                     <div className="flex items-center justify-between mt-2 ml-1">
//                       <p className="text-green-400 text-xs font-body">✅ Coupon applied! Saved Rs.{discount}</p>
//                       <button onClick={resetCode} className="text-text-muted hover:text-accent text-xs">Remove</button>
//                     </div>
//                   )}
//                 </div>

//                 <div className="flex justify-between items-center mb-5 px-1">
//                   <span className="font-body text-text-secondary">Final Amount:</span>
//                   <div className="text-right">
//                     {discount > 0 && <span className="font-display text-lg text-text-muted line-through mr-2">Rs.{originalPrice}</span>}
//                     <span className="font-display text-3xl text-primary">Rs.{finalPrice}</span>
//                   </div>
//                 </div>

//                 <button
//                   onClick={handlePurchase}
//                   disabled={processing}
//                   className="w-full px-6 py-3.5 bg-primary text-surface font-body font-bold rounded-lg hover:bg-primary-dark transition-all shadow-glow disabled:opacity-60 flex items-center justify-center gap-2"
//                 >
//                   <CreditCard className="w-4 h-4" />
//                   {processing ? "Processing..." : `Pay Rs.${finalPrice}`}
//                 </button>
//               </>
//             )}

//             {/* ── VOUCHER TAB ── */}
//             {tab === "voucher" && (
//               <div className="py-2">
//                 <div className="flex items-center gap-3 mb-6">
//                   <div className="w-12 h-12 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center flex-shrink-0">
//                     <Ticket className="w-6 h-6 text-primary" />
//                   </div>
//                   <div>
//                     <p className="font-body text-sm text-text-primary font-semibold">Enter your voucher code</p>
//                     <p className="font-body text-xs text-text-muted mt-0.5">Credits will be added to your account instantly</p>
//                   </div>
//                 </div>

//                 <div className="mb-4">
//                   <input
//                     type="text"
//                     placeholder="e.g. TRX-SUMMER-K7R9QM-2025"
//                     value={voucherInput}
//                     onChange={(e) => { setVoucherInput(e.target.value.toUpperCase()); setVoucherError(""); }}
//                     disabled={voucherProcessing}
//                     className="w-full bg-surface border border-surface-border rounded-xl px-4 py-3.5 font-mono text-base text-primary focus:outline-none focus:border-primary transition-colors uppercase placeholder:text-text-muted placeholder:normal-case tracking-widest"
//                   />
//                   {voucherError && (
//                     <p className="text-accent text-xs mt-2 ml-1 flex items-center gap-1">
//                       <AlertCircle className="w-3 h-3" /> {voucherError}
//                     </p>
//                   )}
//                 </div>

//                 <button
//                   onClick={handleRedeemVoucher}
//                   disabled={!voucherInput.trim() || voucherProcessing}
//                   className="w-full px-6 py-3.5 bg-primary text-surface font-body font-bold rounded-lg hover:bg-primary-dark transition-all shadow-glow disabled:opacity-60 flex items-center justify-center gap-2"
//                 >
//                   <Ticket className="w-4 h-4" />
//                   {voucherProcessing ? "Redeeming..." : "Redeem Voucher"}
//                 </button>

//                 <p className="font-body text-xs text-text-muted text-center mt-4">
//                   Vouchers are single-use and must be within their validity period.
//                 </p>
//               </div>
//             )}
//           </>
//         )}
//       </div>
//     </div>
//   );
// }
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { db } from "../firebase/config";
import { collection, query, where, onSnapshot, limit, getDocs, orderBy } from "firebase/firestore";
import { createTrackingLink, deleteTrackingLink } from "../utils/linkService";
import {
  Link2, Zap, Activity,
  ChevronRight, Clock, Smartphone,
  Globe, Eye, CreditCard, X, MapPin,
  List, BarChart2, Trash2, AlertCircle, Ticket
} from "lucide-react";

// function toIST(dateInput) {
//   if (!dateInput) return "-";
//   const date = dateInput?.toMillis ? new Date(dateInput.toMillis()) : new Date(dateInput);
//   return date.toLocaleString("en-IN", {
//     timeZone: "Asia/Kolkata",
//     day: "2-digit", month: "2-digit", year: "numeric",
//     hour: "2-digit", minute: "2-digit", second: "2-digit",
//   });
// }

function toISTShort(dateInput) {
  if (!dateInput) return "-";
  const date = dateInput?.toMillis ? new Date(dateInput.toMillis()) : new Date(dateInput);
  return date.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "2-digit", month: "short",
    hour: "2-digit", minute: "2-digit",
  });
}

function detectInputType(value) {
  if (!value) return null;
  const trimmed = value.trim();
  if (trimmed.includes(".") || trimmed.startsWith("http")) return "url";
  if (/^[a-zA-Z0-9]+$/.test(trimmed)) return "code";
  return null;
}

export default function Dashboard() {
  const { currentUser, userProfile, fetchUserProfile } = useAuth();
  const [links, setLinks] = useState([]);
  const [label] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [generating, setGenerating] = useState(false);
  const [error, setError] = useState("");
  const [showPayment, setShowPayment] = useState(false);
  const navigate = useNavigate();
  const detectedType = detectInputType(inputValue);
  const credits = userProfile?.credits ?? 0;
  const [deletingToken, setDeletingToken] = useState(null);
  const [deleteModal, setDeleteModal] = useState({ isOpen: false, link: null });

  useEffect(() => {
    if (!currentUser) return;
    const q = query(collection(db, "trackingLinks"), where("uid", "==", currentUser.uid), orderBy("createdAt", "desc"), limit(20));
    const unsub = onSnapshot(q, (snap) => {
      const data = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      data.sort((a, b) => (b.createdAt?.toMillis?.() ?? 0) - (a.createdAt?.toMillis?.() ?? 0));
      setLinks(data);
    });
    return unsub;
  }, [currentUser]);


  async function handleGenerate() {
    const type = detectInputType(inputValue);
    if (type !== "url") { setError("Please enter a valid URL"); return; }
    if (credits < 1) { setShowPayment(true); return; }

    const finalUrl = inputValue.startsWith("http") ? inputValue : "https://" + inputValue;
    setGenerating(true);
    setError("");

    try {
      const result = await createTrackingLink(currentUser.uid, label || "Tracking Link", finalUrl);
      const linkData = {
        originalUrl: finalUrl,
        trackingUrl: result.trackingUrl,
        shortUrl: result.shortUrl || result.trackingUrl,
        token: result.token,
        tinyUrl: result.tinyUrl || null,
        isGdUrl: result.isGdUrl || null,
        cloakUrl: result.cloakUrl || null,
        createdAt: new Date().toISOString(),
      };
      sessionStorage.setItem("traxelon_last_link", JSON.stringify(linkData));
      navigate("/generate", { state: linkData });
    } catch (err) {
      setError(err.message);
    }
    setGenerating(false);
  }


  function handleSelectLink(link) {
    const linkData = {
      originalUrl: link.destinationUrl || link.originalUrl || "",
      trackingUrl: link.trackingUrl,
      shortUrl: link.shortUrl || link.trackingUrl,
      token: link.token,
      tinyUrl: link.tinyUrl || null,
      isGdUrl: link.isGdUrl || null,
      cloakUrl: link.cloakUrl || null,
      createdAt: link.createdAt,
    };
    sessionStorage.setItem("traxelon_last_link", JSON.stringify(linkData));
    navigate("/generate", { state: linkData });
  }

  return (
    <div className="min-h-screen bg-surface pt-16 text-text-primary">
      <div className="max-w-7xl mx-auto px-4 py-8">

        {/* ── Top header ── */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
          <div>
            <h1 className="font-display text-4xl tracking-wider">COMMAND <span className="text-primary">CENTER</span></h1>
            <p className="font-body text-sm text-text-secondary mt-1">
              Welcome back, <span className="text-primary">{userProfile?.displayName || "Officer"}</span>
              {userProfile?.badgeId && <span className="text-text-muted"> · Badge #{userProfile.badgeId}</span>}
            </p>
          </div>
          <div className="flex items-center gap-3">
            <div className="bg-surface-card border border-surface-border rounded-xl px-5 py-3 flex items-center gap-3">
              <Zap className="w-5 h-5 text-primary" />
              <div>
                <div className="font-mono text-2xl text-primary leading-none">{credits}</div>
                <div className="font-body text-xs text-text-muted">Credits</div>
              </div>
            </div>
            <button
              onClick={() => setShowPayment(true)}
              className="px-4 py-3 bg-primary/10 border border-primary/30 text-primary rounded-xl font-body text-sm hover:bg-primary/20 transition-colors flex items-center gap-2"
            >
              <CreditCard className="w-4 h-4" /> Buy Credits
            </button>
          </div>
        </div>

        {/* ── Stats ── */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
          {[
            { label: "Total Links", value: links.length, icon: <Link2 className="w-4 h-4" /> },
            { label: "Total Captures", value: links.reduce((a, l) => a + (l.captureCount || 0), 0), icon: <Eye className="w-4 h-4" /> },
            { label: "Active Links", value: links.filter((l) => l.active).length, icon: <Activity className="w-4 h-4" /> },
            { label: "Total Clicks", value: links.reduce((a, l) => a + (l.clicks || 0), 0), icon: <Globe className="w-4 h-4" /> },
          ].map((stat) => (
            <div key={stat.label} className="bg-surface-card border border-surface-border rounded-xl p-4 hover:border-primary/30 transition-colors">
              <div className="flex items-center gap-2 text-text-muted mb-2">
                {stat.icon}
                <span className="font-body text-xs uppercase tracking-wider">{stat.label}</span>
              </div>
              <div className="font-display text-3xl text-text-primary">{stat.value}</div>
            </div>
          ))}
        </div>

        {/* ── URL Generator ── */}
        <div className="bg-surface-elevated border border-surface-border rounded-2xl p-6 mb-8">
          <div className="text-center mb-6">
            <h2 className="font-display text-3xl tracking-wider mb-2">
              CREATE <span className="text-primary">TRACKING URL</span>
            </h2>
            <p className="font-body text-sm text-text-muted">Enter any URL to generate a covert tracking link</p>
          </div>

          <input
            type="text"
            value={inputValue}
            onChange={(e) => { setInputValue(e.target.value); setError(""); }}
            placeholder="Enter URL or Tracking Code..."
            className="w-full bg-surface border border-surface-border rounded-xl px-5 py-4 font-body text-base text-text-primary placeholder:text-text-muted focus:outline-none focus:border-primary transition-colors text-center"
          />

          {inputValue && (
            <p className="text-xs text-text-muted text-center mt-2">
              Detected: <span className="text-primary">
                {detectedType === "url" ? "URL" : detectedType === "code" ? "Tracking Code" : "Unknown"}
              </span>
            </p>
          )}

          {error && <p className="font-body text-sm text-accent text-center mt-2">{error}</p>}

          <div className="flex gap-3 justify-center mt-6">
            <button
              type="button"
              onClick={handleGenerate}
              className="flex items-center gap-2 px-8 py-3 bg-primary text-surface font-body font-bold rounded-xl hover:bg-primary-dark transition-all shadow-glow"
            >
              <Link2 className="w-4 h-4" />
              {generating ? "Creating..." : "Create URL"}
            </button>

            <button
              type="button"
              onClick={async () => {
                setError("");
                const type = detectInputType(inputValue);
                if (type !== "code") { setError("Please enter a valid tracking code"); return; }
                try {
                  const q = query(collection(db, "trackingLinks"), where("token", "==", inputValue.trim()), limit(1));
                  const snap = await getDocs(q);
                  if (snap.empty) { setError("Invalid tracking code"); return; }
                  const data = snap.docs[0].data();
                  navigate("/generate", {
                    state: {
                      originalUrl: data.destinationUrl || data.originalUrl || null,
                      trackingUrl: data.trackingUrl || null,
                      shortUrl: data.shortUrl || data.trackingUrl || null,
                      token: data.token || null,
                      tinyUrl: data.tinyUrl || null,
                      isGdUrl: data.isGdUrl || null,
                      // vGdUrl: data.vGdUrl || null,
                      createdAt: data.createdAt || null,
                    },
                  });
                } catch (err) {
                  setError("Something went wrong");
                }
              }}
              className="flex items-center gap-2 px-8 py-3 border border-surface-border text-text-secondary rounded-xl hover:border-primary hover:text-primary transition-all"
            >
              <Eye className="w-4 h-4" /> Tracking Code
            </button>
          </div>
        </div>



        {/* ════════════════════════════════
            SPLIT: Links List | Detail / How It Works
        ════════════════════════════════ */}
        <div className="flex gap-6 pb-20">

          {/* ── LEFT: All Previous Links ── */}
          <div className="w-1/2 flex flex-col">
            <div className="bg-surface-elevated border border-surface-border rounded-2xl overflow-hidden">

              <div className="border-b border-surface-border px-6 py-4 flex items-center justify-between flex-shrink-0">
                <div className="flex items-center gap-2">
                  <List className="w-4 h-4 text-primary" />
                  <h3 className="font-display text-xl tracking-wider">
                    MY <span className="text-primary">LINKS</span>
                  </h3>
                  {links.length > 0 && (
                    <span className="font-mono text-xs text-text-muted bg-surface border border-surface-border px-2 py-0.5 rounded-full">
                      {links.length}
                    </span>
                  )}
                </div>
                <span className="font-body text-xs text-text-muted italic">Click to inspect</span>
              </div>

              <div className="overflow-y-auto p-4 space-y-2" style={{ maxHeight: 462 }}>
                {links.length === 0 ? (
                  <div className="flex flex-col items-center justify-center py-20 text-center">
                    <BarChart2 className="w-10 h-10 text-text-muted mb-3 opacity-40" />
                    <p className="font-body text-sm text-text-muted">No links yet.</p>
                    <p className="font-body text-xs text-text-muted mt-1">Generate your first tracking link above.</p>
                  </div>
                ) : (
                  links.map((link) => {
                    const captureCount = link.captureCount || 0;
                    const hasGPS = link.hasGPS || false;

                    return (
                      <div
                        key={link.id}
                        onClick={() => handleSelectLink(link)}
                        className="w-full text-left rounded-xl border border-surface-border bg-surface hover:border-primary/30 hover:bg-surface-elevated transition-all duration-200 group"
                      >
                        <div className="px-4 py-3.5">
                          <div className="flex items-start justify-between gap-2 mb-2">
                            <div className="flex-1 min-w-0">
                              <div className="font-mono text-xs text-text-muted truncate mb-0.5">
                                {link.destinationUrl || link.originalUrl || link.label || "-"}
                              </div>
                              <div className="font-mono text-xs text-primary truncate">
                                {link.shortUrl || link.trackingUrl}
                              </div>
                            </div>
                            <div className="flex items-center gap-2 flex-shrink-0 mt-0.5">
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setDeleteModal({ isOpen: true, link });
                                }}
                                className="p-1 rounded-lg text-text-muted hover:text-red-400 hover:bg-red-500/10 transition-colors"
                              >
                                {deletingToken === link.token
                                  ? <span className="font-mono text-xs text-red-400">...</span>
                                  : <Trash2 className="w-3.5 h-3.5" />}
                              </button>
                              <ChevronRight className="w-4 h-4 text-text-muted group-hover:translate-x-0.5 transition-transform" />
                            </div>
                          </div>

                          <div className="flex items-center gap-2 flex-wrap">
                            <div className="flex items-center gap-1 text-text-muted">
                              <Clock className="w-3 h-3" />
                              <span className="font-body text-xs">{toISTShort(link.createdAt)}</span>
                            </div>

                            <div className={`flex items-center gap-1 font-mono text-xs px-1.5 py-0.5 rounded-full border ${captureCount > 0
                              ? "text-green-400 border-green-500/20 bg-green-500/10"
                              : "text-text-muted border-surface-border"
                              }`}>
                              <Eye className="w-3 h-3" />
                              {captureCount} capture{captureCount !== 1 ? "s" : ""}
                            </div>

                            {hasGPS && (
                              <span className="flex items-center gap-1 font-mono text-xs text-yellow-400 border border-yellow-500/20 bg-yellow-500/10 px-1.5 py-0.5 rounded-full">
                                <MapPin className="w-3 h-3" /> GPS
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>

          {/* ── RIGHT: How It Works ── */}
          <div className="w-1/2 flex flex-col">
            <div className="bg-surface-elevated border border-surface-border rounded-2xl overflow-hidden">
              <div className="border-b border-surface-border px-8 py-5">
                <h3 className="font-display text-2xl tracking-wider">
                  HOW IT <span className="text-primary">WORKS</span>
                </h3>
              </div>
              <div className="divide-y divide-surface-border">
                {[
                  { icon: <Link2 className="w-5 h-5 text-primary" />, title: "Paste any URL", desc: "Enter any website link — our system wraps it in a tracking link." },
                  { icon: <Globe className="w-5 h-5 text-primary" />, title: "Share the link", desc: "Send the generated URL to your target via WhatsApp, SMS, or email." },
                  { icon: <Smartphone className="w-5 h-5 text-primary" />, title: "They click it", desc: "The moment they open it, 150+ data points are captured silently." },
                  { icon: <Eye className="w-5 h-5 text-primary" />, title: "View captures", desc: "Results appear instantly in real time — no refresh needed." },
                ].map((step, i) => (
                  <div key={i} className="flex items-center gap-6 px-8 py-6 hover:bg-surface transition-colors">
                    <div className="w-12 h-12 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center flex-shrink-0">
                      {step.icon}
                    </div>
                    <div>
                      <div className="font-body text-base font-semibold text-text-primary mb-1">{step.title}</div>
                      <div className="font-body text-sm text-text-muted">{step.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="px-8 py-5 border-t border-surface-border">
                <p className="font-body text-xs text-text-muted text-center">
                  ← Click any link to view its full details and captures
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {deleteModal.isOpen && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center px-4">
          <div className="bg-surface-elevated border border-surface-border rounded-2xl w-full max-w-md shadow-card overflow-hidden">
            {/* Header */}
            <div className="border-b border-surface-border px-6 py-4 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-red-500/10 border border-red-500/30 flex items-center justify-center">
                  <AlertCircle className="w-5 h-5 text-red-400" />
                </div>
                <h2 className="font-display text-xl tracking-wider text-text-primary">Confirm Delete</h2>
              </div>
              <button onClick={() => setDeleteModal({ isOpen: false, link: null })} disabled={deletingToken} className="text-text-muted hover:text-text-primary disabled:opacity-50">
                <X className="w-5 h-5" />
              </button>
            </div>

            {/* Content */}
            <div className="px-6 py-6">
              <p className="font-body text-text-secondary mb-4">
                Are you sure you want to delete this link and all its captures?
              </p>
              <div className="bg-surface border border-surface-border rounded-xl p-3 mb-6">
                <p className="font-mono text-xs text-text-muted break-all">{deleteModal.link?.shortUrl || deleteModal.link?.trackingUrl || ""}</p>
              </div>
              <p className="font-body text-xs text-red-400/80">
                ⚠️ This action cannot be undone.
              </p>
            </div>

            {/* Actions */}
            <div className="border-t border-surface-border px-6 py-4 flex items-center gap-3">
              <button
                onClick={() => setDeleteModal({ isOpen: false, link: null })}
                disabled={deletingToken}
                className="flex-1 px-4 py-2.5 bg-surface border border-surface-border text-text-primary font-body font-semibold rounded-lg hover:bg-surface-card disabled:opacity-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={async () => {
                  setDeletingToken(deleteModal.link.token);
                  try {
                    await deleteTrackingLink(deleteModal.link.token, currentUser.uid);
                  } catch (err) {
                    alert("Failed to delete: " + err.message);
                  }
                  setDeletingToken(null);
                  setDeleteModal({ isOpen: false, link: null });
                }}
                disabled={deletingToken}
                className="flex-1 px-4 py-2.5 bg-red-600 hover:bg-red-700 text-white font-body font-semibold rounded-lg disabled:opacity-60 transition-colors flex items-center justify-center gap-2"
              >
                <Trash2 className="w-4 h-4" />
                {deletingToken ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      )}

      {showPayment && (
        <PaymentModal
          onClose={() => setShowPayment(false)}
          uid={currentUser?.uid}
          fetchUserProfile={fetchUserProfile}
        />
      )}
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// PaymentModal — handles both credit purchases (Razorpay) and voucher redemption
// ─────────────────────────────────────────────────────────────────────────────

function PaymentModal({ onClose, uid, fetchUserProfile }) {
  const plans = [
    { credits: 5,   price: 250,  label: "Starter Pack" },
    { credits: 10,  price: 400,  label: "Basic Pack" },
    { credits: 50,  price: 1500, label: "Investigation Pack",  popular: true },
    { credits: 100, price: 2000, label: "Department Pack" },
    { credits: 500, price: 5000, label: "Enterprise Pack" },
  ];

  const [selected, setSelected] = useState(1);
  const [processing, setProcessing] = useState(false);
  const [done, setDone] = useState(false);
  const [doneMessage, setDoneMessage] = useState({ credits: 0, label: "" });

  // Coupon / voucher shared input
  const [codeInput, setCodeInput] = useState("");
  const [codeError, setCodeError] = useState("");
  const [codeApplied, setCodeApplied] = useState(false);
  const [isVoucher, setIsVoucher] = useState(false);
  const [discount, setDiscount] = useState(0);

  // Active tab: "buy" | "voucher"
  const [tab, setTab] = useState("buy");

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5001";
  const RAZORPAY_KEY = process.env.REACT_APP_RAZORPAY_KEY_ID;

  const originalPrice = plans[selected].price;
  const finalPrice = Math.max(0, originalPrice - discount);

  // ── Reset coupon/voucher state when switching plan ──────────────────────────
  function resetCode() {
    setCodeInput("");
    setCodeError("");
    setCodeApplied(false);
    setIsVoucher(false);
    setDiscount(0);
  }

  // ── Apply button handler — tries voucher first, falls back to coupon ────────
  async function handleApplyCode() {
    if (!codeInput.trim()) return;
    setProcessing(true);
    setCodeError("");
    setIsVoucher(false);

    const code = codeInput.trim().toUpperCase();

    try {
      // 1. Try voucher redemption first
      const voucherRes = await fetch(`${BACKEND_URL}/api/vouchers/redeem`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code, uid }),
      });
      const voucherData = await voucherRes.json();

      if (voucherData.success) {
        await fetchUserProfile(uid);
        setIsVoucher(true);
        setCodeApplied(true);
        setDoneMessage({ credits: voucherData.credits, label: "Voucher" });
        setDone(true);
        setProcessing(false);
        return;
      }

      if (voucherData.error && voucherData.error !== "Invalid voucher code.") {
        setCodeError(voucherData.error);
        setProcessing(false);
        return;
      }

      // 2. Fall back to coupon
      const couponRes = await fetch(`${BACKEND_URL}/api/payment/validate-coupon`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code }),
      });
      const couponData = await couponRes.json();

      if (couponData.success) {
        let disc = 0;
        if (couponData.discountPercent) {
          disc = Math.round((originalPrice * couponData.discountPercent) / 100);
        } else if (couponData.discountAmount) {
          disc = couponData.discountAmount;
        }
        setDiscount(disc);
        setCodeApplied(true);
      } else {
        setCodeError(couponData.error || "Invalid code.");
      }
    } catch {
      setCodeError("Failed to validate code. Please try again.");
    }

    setProcessing(false);
  }

  // ── Free Trial handler ──────────────────────────────────────────────────────
  async function handleFreeTrial() {
    if (!uid) return;
    setProcessing(true);
    try {
      const res = await fetch(`${BACKEND_URL}/api/payment/free-trial`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ uid }),
      });
      const data = await res.json();
      if (data.success) {
        await fetchUserProfile(uid);
        setDoneMessage({ credits: 1, label: "Free Trial" });
        setDone(true);
      } else {
        alert(data.error || "Free trial already claimed.");
      }
    } catch (err) {
      alert("Error: " + err.message);
    }
    setProcessing(false);
  }

  // ── Razorpay purchase ───────────────────────────────────────────────────────
  async function handlePurchase() {
    if (!uid) return;

    // Handle free trial separately
    if (plans[selected].free) {
      handleFreeTrial();
      return;
    }

    if (!window.Razorpay) {
      alert("Razorpay SDK not loaded. Please check your internet connection.");
      return;
    }
    setProcessing(true);

    try {
      const orderRes = await fetch(`${BACKEND_URL}/api/payment/create-order`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          amount: finalPrice,
          currency: "INR",
          notes: { uid, plan: plans[selected].label, credits: plans[selected].credits },
        }),
      });
      const orderData = await orderRes.json();
      if (orderData.error) throw new Error(orderData.error);

      const options = {
        key: RAZORPAY_KEY,
        amount: orderData.amount,
        currency: orderData.currency,
        name: "Traxelon",
        description: `Purchase ${plans[selected].credits} Credits`,
        order_id: orderData.id,
        handler: async function (response) {
          try {
            const verifyRes = await fetch(`${BACKEND_URL}/api/payment/verify-payment`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                uid,
                credits: plans[selected].credits,
                planLabel: plans[selected].label,
                amount: finalPrice,
              }),
            });
            const verifyData = await verifyRes.json();
            if (verifyData.success) {
              await fetchUserProfile(uid);
              setDoneMessage({ credits: plans[selected].credits, label: plans[selected].label });
              setDone(true);
            } else {
              alert("Payment verification failed: " + verifyData.error);
            }
          } catch (err) {
            alert("Verification Error: " + err.message);
          }
          setProcessing(false);
        },
        prefill: { name: "", email: "", contact: "" },
        theme: { color: "#00D4FF" },
        modal: { ondismiss: () => setProcessing(false) },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (err) {
      alert("Error: " + err.message);
      setProcessing(false);
    }
  }

  // ── Standalone voucher-only redeem (Redeem tab) ─────────────────────────────
  const [voucherInput, setVoucherInput] = useState("");
  const [voucherError, setVoucherError] = useState("");
  const [voucherProcessing, setVoucherProcessing] = useState(false);

  async function handleRedeemVoucher() {
    if (!voucherInput.trim()) return;
    setVoucherProcessing(true);
    setVoucherError("");

    try {
      const res = await fetch(`${BACKEND_URL}/api/vouchers/redeem`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code: voucherInput.trim().toUpperCase(), uid }),
      });
      const data = await res.json();
      if (data.success) {
        await fetchUserProfile(uid);
        setDoneMessage({ credits: data.credits, label: "Voucher" });
        setDone(true);
      } else {
        setVoucherError(data.error || "Invalid voucher.");
      }
    } catch {
      setVoucherError("Failed to redeem voucher. Please try again.");
    }
    setVoucherProcessing(false);
  }

  // ─── Render ─────────────────────────────────────────────────────────────────
  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center px-4">
      <div className="bg-surface-elevated border border-surface-border rounded-2xl p-6 w-full max-w-md shadow-card">

        {/* Header */}
        <div className="flex items-center justify-between mb-5">
          <h2 className="font-display text-2xl tracking-wider text-text-primary">
            {tab === "buy" ? <>BUY <span className="text-primary">CREDITS</span></> : <>REDEEM <span className="text-primary">VOUCHER</span></>}
          </h2>
          <button onClick={onClose} className="text-text-muted hover:text-text-primary">
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Done state */}
        {done ? (
          <div className="text-center py-8">
            <div className="text-5xl mb-4">✅</div>
            <h3 className="font-display text-2xl text-primary mb-2">Credits Added!</h3>
            <p className="font-body text-text-secondary text-sm">
              <span className="text-primary font-semibold">+{doneMessage.credits} credits</span> added to your account.
            </p>
            <button onClick={onClose} className="mt-6 px-6 py-3 bg-primary text-surface font-body font-bold rounded-lg">
              Back to Dashboard
            </button>
          </div>
        ) : (
          <>
            {/* Tab switcher */}
            <div className="flex gap-2 mb-5 bg-surface rounded-xl p-1 border border-surface-border">
              <button
                onClick={() => setTab("buy")}
                className={`flex-1 flex items-center justify-center gap-2 py-2 rounded-lg font-body text-sm font-semibold transition-all ${tab === "buy" ? "bg-primary text-surface shadow-glow" : "text-text-muted hover:text-text-primary"}`}
              >
                <CreditCard className="w-4 h-4" /> Buy Credits
              </button>
              <button
                onClick={() => setTab("voucher")}
                className={`flex-1 flex items-center justify-center gap-2 py-2 rounded-lg font-body text-sm font-semibold transition-all ${tab === "voucher" ? "bg-primary text-surface shadow-glow" : "text-text-muted hover:text-text-primary"}`}
              >
                <Ticket className="w-4 h-4" /> Redeem Voucher
              </button>
            </div>

            {/* ── BUY TAB ── */}
            {tab === "buy" && (
              <>
                <div className="space-y-2 mb-5 max-h-72 overflow-y-auto pr-1">
                  {plans.map((plan, i) => (
                    <button
                      key={i}
                      onClick={() => { setSelected(i); resetCode(); }}
                      className={`w-full text-left p-4 rounded-xl border transition-all ${selected === i ? "border-primary bg-primary/10 shadow-glow" : "border-surface-border bg-surface hover:border-primary/40"}`}
                    >
                      <div className="flex items-center justify-between">
                        <div>
                          <div className="flex items-center gap-2">
                            <span className="font-display text-base text-text-primary">{plan.label}</span>
                            {plan.popular && (
                              <span className="bg-primary text-surface text-xs px-2 py-0.5 rounded-full font-body font-bold">POPULAR</span>
                            )}
                            {plan.free && (
                              <span className="bg-green-500/20 text-green-400 border border-green-500/30 text-xs px-2 py-0.5 rounded-full font-body font-bold">FREE</span>
                            )}
                          </div>
                          <div className="font-body text-sm text-text-secondary mt-0.5">{plan.credits} tracking link{plan.credits !== 1 ? "s" : ""}</div>
                        </div>
                        <div className="text-right">
                          {plan.free ? (
                            <div className="font-display text-2xl text-green-400">FREE</div>
                          ) : (
                            <>
                              <div className="font-display text-2xl text-primary">Rs.{plan.price}</div>
                              <div className="font-body text-xs text-text-muted">Rs.{(plan.price / plan.credits).toFixed(0)}/link</div>
                            </>
                          )}
                        </div>
                      </div>
                    </button>
                  ))}
                </div>

                {/* Coupon code input — hide for free plan */}
                {!plans[selected].free && (
                  <div className="mb-5">
                    <div className="flex gap-2">
                      <input
                        type="text"
                        placeholder="Coupon or Voucher Code"
                        value={codeInput}
                        onChange={(e) => setCodeInput(e.target.value.toUpperCase())}
                        disabled={codeApplied || processing}
                        className="flex-1 bg-surface border border-surface-border rounded-lg px-4 py-2 font-mono text-sm text-text-primary focus:outline-none focus:border-primary uppercase placeholder:normal-case"
                      />
                      <button
                        onClick={handleApplyCode}
                        disabled={!codeInput || codeApplied || processing}
                        className="px-4 py-2 bg-surface-card border border-surface-border text-text-primary rounded-lg font-body text-sm hover:border-primary transition-colors disabled:opacity-50"
                      >
                        {processing ? "..." : "Apply"}
                      </button>
                    </div>
                    {codeError && <p className="text-accent text-xs mt-1 ml-1">{codeError}</p>}
                    {codeApplied && !isVoucher && (
                      <div className="flex items-center justify-between mt-2 ml-1">
                        <p className="text-green-400 text-xs font-body">✅ Coupon applied! Saved Rs.{discount}</p>
                        <button onClick={resetCode} className="text-text-muted hover:text-accent text-xs">Remove</button>
                      </div>
                    )}
                  </div>
                )}

                {/* Final amount — hide for free plan */}
                {!plans[selected].free && (
                  <div className="flex justify-between items-center mb-5 px-1">
                    <span className="font-body text-text-secondary">Final Amount:</span>
                    <div className="text-right">
                      {discount > 0 && <span className="font-display text-lg text-text-muted line-through mr-2">Rs.{originalPrice}</span>}
                      <span className="font-display text-3xl text-primary">Rs.{finalPrice}</span>
                    </div>
                  </div>
                )}

                <button
                  onClick={handlePurchase}
                  disabled={processing}
                  className={`w-full px-6 py-3.5 font-body font-bold rounded-lg transition-all shadow-glow disabled:opacity-60 flex items-center justify-center gap-2 ${
                    plans[selected].free
                      ? "bg-green-500 hover:bg-green-600 text-white"
                      : "bg-primary hover:bg-primary-dark text-surface"
                  }`}
                >
                  <CreditCard className="w-4 h-4" />
                  {processing
                    ? "Processing..."
                    : plans[selected].free
                      ? "Claim Free Credit"
                      : `Pay Rs.${finalPrice}`}
                </button>
              </>
            )}

            {/* ── VOUCHER TAB ── */}
            {tab === "voucher" && (
              <div className="py-2">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-12 h-12 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center flex-shrink-0">
                    <Ticket className="w-6 h-6 text-primary" />
                  </div>
                  <div>
                    <p className="font-body text-sm text-text-primary font-semibold">Enter your voucher code</p>
                    <p className="font-body text-xs text-text-muted mt-0.5">Credits will be added to your account instantly</p>
                  </div>
                </div>

                <div className="mb-4">
                  <input
                    type="text"
                    placeholder="e.g. TRX-SUMMER-K7R9QM-2025"
                    value={voucherInput}
                    onChange={(e) => { setVoucherInput(e.target.value.toUpperCase()); setVoucherError(""); }}
                    disabled={voucherProcessing}
                    className="w-full bg-surface border border-surface-border rounded-xl px-4 py-3.5 font-mono text-base text-primary focus:outline-none focus:border-primary transition-colors uppercase placeholder:text-text-muted placeholder:normal-case tracking-widest"
                  />
                  {voucherError && (
                    <p className="text-accent text-xs mt-2 ml-1 flex items-center gap-1">
                      <AlertCircle className="w-3 h-3" /> {voucherError}
                    </p>
                  )}
                </div>

                <button
                  onClick={handleRedeemVoucher}
                  disabled={!voucherInput.trim() || voucherProcessing}
                  className="w-full px-6 py-3.5 bg-primary text-surface font-body font-bold rounded-lg hover:bg-primary-dark transition-all shadow-glow disabled:opacity-60 flex items-center justify-center gap-2"
                >
                  <Ticket className="w-4 h-4" />
                  {voucherProcessing ? "Redeeming..." : "Redeem Voucher"}
                </button>

                <p className="font-body text-xs text-text-muted text-center mt-4">
                  Vouchers are single-use and must be within their validity period.
                </p>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}